import $ from "jquery";

// Unwrap specific selector elements from elements and return element
export function unwrap(element, selector) {}

// Unwrap specific selector elements from html and return html
export function unwrapHTML(html, selector) {
  const doc = document.implementation.createHTMLDocument("");

  doc.body.innerHTML = html;

  var instances = doc.querySelectorAll(selector);

  instances.forEach((instance) => {
    $(instance).contents().unwrap();
  });

  return doc.body.innerHTML;
}
